import { twMerge } from "tailwind-merge";

type IActionButton = {
  icon: React.ElementType;
  onClick: () => void;
  label: string;
  title: string;
  className?: string;
  variant?: "primary" | "secondary" | "danger";
  isHidden?: boolean;
};

export const ActionButton = ({
  icon: Icon,
  onClick,
  label,
  title,
  className,
  variant = "primary",
  isHidden = false,
}: IActionButton) => {
  const variants = {
    primary:
      "bg-primary-500 hover:bg-primary-800 text-white shadow-sm hover:shadow-md",
    secondary:
      "bg-white hover:bg-slate-50 text-slate-700 border border-slate-200 shadow-sm hover:shadow-md hover:border-slate-300",
    danger: "bg-red-500 hover:bg-red-600 text-white shadow-sm hover:shadow-md",
  };

  return (
    <button
      onClick={onClick}
      className={twMerge(
        "flex items-center justify-center gap-2 px-5 py-3 rounded-lg font-medium transition-all duration-200 hover:-translate-y-0.5",
        variants[variant],
        className,
      )}
      aria-label={label}
    >
      <Icon size={18} />
      <span
        className={twMerge(
          "hidden md:block xl:hidden 2xl:inline-block",
          isHidden && "hidden",
          !isHidden && "md:block xl:hidden 2xl:inline-block",
        )}
      >
        {title}
      </span>
    </button>
  );
};
